module.exports = __webpack_public_path__ + "img/22 Animation 2-squashed.2ab90b04.jpg";